module.exports = __webpack_public_path__ + "static/media/LAN_01.95355754.jpeg";